<ngx-simplebar class="responsiveScrollContainer h-full">
  <div class="container grid-container customerHomeContainer">
    <div class="widget severityOverview">
      <app-severity-overview [severityCounts]="customerHomeFacade.severityCounts()" />
    </div>
    <div class="widget expectedEnergyLoss">
      <app-expected-energy-loss
        [energyLoss]="customerHomeFacade.energyLossYearly()"
        [expectedEnergyLossPerDay]="customerHomeFacade.expectedEnergyLossPerDay()"
        [isCustomerYearly]="true"
      ></app-expected-energy-loss>
    </div>
    <div class="widget energyLossYearly">
      <app-energy-loss-yearly-chart
        [chartData]="customerHomeFacade.lineChartEnergyLoss()"
        chartId="yearlyEnergyLossChart"
      ></app-energy-loss-yearly-chart>
    </div>

    <div class="widget faultList">
      <app-gate-fault-table [gateFaults]="customerHomeFacade.gateFaultState()"></app-gate-fault-table>
    </div>
    <div class="widget map">
      <app-customer-map></app-customer-map>
    </div>

    <div class="widget predictiveList">
      @if (customerId(); as id) {
        <app-service-list type="predictive" [asset]="{ id, assetType: assetTypes.CUSTOMER }"></app-service-list>
      }
    </div>
    <div class="widget contractsList">
      @if (customerId(); as id) {
        <app-service-list type="contracts" [asset]="{ id, assetType: assetTypes.CUSTOMER }"> </app-service-list>
      }
    </div>
  </div>
</ngx-simplebar>
